import AvenirNextBold from '@/assets/fonts/families/avenir-next/AvenirNext-Bold.landrover';
import AvenirNextDemiBold from '@/assets/fonts/families/avenir-next/AvenirNext-DemiBold.landrover';
import AvenirNextItalic from '@/assets/fonts/families/avenir-next/AvenirNext-Italic.landrover';
import AvenirNextLight from '@/assets/fonts/families/avenir-next/AvenirNext-Light.landrover';
import AvenirNextMedium from '@/assets/fonts/families/avenir-next/AvenirNext-Medium.landrover';
import AvenirNext from '@/assets/fonts/families/avenir-next/AvenirNext.landrover';

const avenirNextFonts = [
	AvenirNextLight,
	AvenirNext,
	AvenirNextItalic,
	AvenirNextMedium,
	AvenirNextDemiBold,
	AvenirNextBold,
];

export default avenirNextFonts;
